import { useMutation } from '@tanstack/react-query'
import { closeTicket } from '../index'

const useCloseTicket = () => {
  return useMutation({
    mutationFn: ({ payload }: { payload: { ticketId: string | undefined } }) =>
      closeTicket(payload),
  })
}

export default useCloseTicket
